import type { SiteCmsDraftResponse, SiteCmsPageDraft } from '@shared/types/entities';

import { cmsSearchMatches } from './site-cms-interaction-model';
import { cmsPageInMenu } from './site-cms-pages-model';

export type CmsPageFilter = 'all' | 'included' | 'private' | 'unlisted';
export type CmsPageSort = 'position' | 'name' | 'visibility';

/** The table is a view over the live draft; sorting or searching never mutates page order. */
export function cmsPageTableRows(
  draft: Pick<SiteCmsDraftResponse, 'pages' | 'headerMenu'>,
  search: string,
  filter: CmsPageFilter,
  sort: CmsPageSort = 'position',
): SiteCmsPageDraft[] {
  const filtered = draft.pages.filter(page => {
    if (!cmsSearchMatches(`${page.title} ${page.slug} ${page.description}`, search)) return false;
    if (filter === 'private') return page.visibility === 'DRAFT';
    if (filter === 'included') return page.visibility !== 'DRAFT';
    if (filter === 'unlisted') return !cmsPageInMenu(draft.headerMenu, page.slug);
    return true;
  });
  if (sort === 'position') return filtered;
  return filtered.sort((left, right) => {
    if (sort === 'name') return left.title.localeCompare(right.title, 'fr', { sensitivity: 'base' });
    const status = Number(left.visibility === 'DRAFT') - Number(right.visibility === 'DRAFT');
    return status || left.title.localeCompare(right.title, 'fr', { sensitivity: 'base' });
  });
}
